/**
 * Debug helper to test projection math from browser console
 * Usage: Open browser dev console and call window.testProjectionMath()
 */

// Add to window for console access
declare global {
  interface Window {
    testProjectionMath: () => void
  }
}

import { runAllTests } from './cameraProjection.test'

export function setupDebugConsole() {
  window.testProjectionMath = () => {
    console.log('%c🔬 Running Projection Math Tests', 'color: blue; font-size: 14px; font-weight: bold;')
    runAllTests()
  }
  
  console.log('%c✓ Debug console ready. Type testProjectionMath() to run tests', 'color: green;')
}
